import { useState } from 'react';
import { useTracking } from 'react-tracking';
import loadable from '@loadable/component';
import { Textfield } from '@simplywallst/ui-core';
import { Heading } from '@simplywallst/ui-core/next';
import type { Brokerage } from '../../../../components/PortfolioLinking/hooks/useBrokerSearch';
import { PopularBrokerage } from '../../../../components/PortfolioLinking/components/PopularBrokerage';
import useUser from '@/hooks/useUser';
import SearchSolid from '@simplywallst/ui-core/icons/SearchSolid';

const GuestRegistrationModal = loadable(
  () => import('@/components/GuestRegistrationModal')
);
const CreateLinkedPortfolio = loadable(
  () => import('../../../../components/PortfolioLinking'),
  {
    resolveComponent: (c) => c.CreateLinkedPortfolio,
  }
);

const LoggedOutContent = () => {
  const [openModal, setOpenModal] = useState(false);
  const { trackEvent } = useTracking();

  return (
    <>
      <div
        className="grid gap-x1_5 px-x2 sm:px-x3"
        data-cy-id="portfolio-linking"
      >
        <Heading as="h2">Sync your broker</Heading>
        <button
          type="button"
          onClick={() => {
            setOpenModal(true);
          }}
          className="cursor-text"
        >
          <Textfield
            type="search"
            placeholder="Search 2,000+ brokers worldwide"
            readOnly
            prefix={
              <SearchSolid
                fill="var(--textfield-addon-color)"
                aria-hidden="true"
                className="grid place-content-center"
              />
            }
          />
        </button>
      </div>
      <PopularBrokerage onSelect={() => setOpenModal(true)} />
      {openModal && (
        <GuestRegistrationModal
          canClose
          onClose={() => {
            trackEvent({
              action: 'close',
              modifier: 'log_in_sign_up',
            });
            setOpenModal(false);
          }}
          onRegisterSuccess={() => {
            trackEvent({
              subject: 'DemoPortfolioAddPortfolioWidgetLinked',
              modifier: 'registration',
              action: 'success',
            });
            setOpenModal(false);
          }}
          onLoginSuccess={() => {
            trackEvent({
              subject: 'DemoPortfolioAddPortfolioWidgetLinked',
              modifier: 'login',
              action: 'success',
            });
            setOpenModal(false);
          }}
        />
      )}
    </>
  );
};

const LoggedInContent = () => {
  const [brokerage, setBrokerage] = useState<Brokerage | undefined>(undefined);

  return (
    <>
      <div
        className="grid gap-x1_5 px-x2 sm:px-x3"
        data-cy-id="portfolio-linking"
      >
        <Heading as="h2">Sync your broker</Heading>
        <CreateLinkedPortfolio
          brokerage={brokerage}
          setBrokerage={setBrokerage}
        />
      </div>
      <PopularBrokerage onSelect={setBrokerage} />
    </>
  );
};

export const NewLinkedPortfolio = () => {
  const { data } = useUser();
  return data.loggedIn ? <LoggedInContent /> : <LoggedOutContent />;
};
